const listeners = new Set()

export const PLAN_LIMIT_CODE = {
    SEAT: 'PLAN_SEAT_LIMIT_EXCEEDED',
    TEMPLATE: 'PLAN_ACTIVE_TEMPLATE_LIMIT_EXCEEDED',
}

export const isPlanLimitErrorCode = code =>
    typeof code === 'string' && code.startsWith('PLAN_')

export const subscribePlanLimitBlocked = listener => {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export const emitPlanLimitBlocked = payload => {
    if (!payload) return
    listeners.forEach(listener => {
        try {
            listener(payload)
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('plan limit listener failed', err)
        }
    })
}

export const getPlanLimitCode = data =>
    data?.code || data?.ErrorCode || data?.errorCode || null
